<template>
    <div v-if="loader" style="height: 250px; line-height: 250px;">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div v-else class="row ma-4" style="width: 70%;">
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.companyName') }}<span class="red">*</span></v-card-title>
                </div>
                <div class="row">
                <v-text-field v-model="companyData.name"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.CompanyName')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>

            <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.description') }}</v-card-title>
                </div>
          
          
                <div class="row">
                <v-text-field v-model="companyData.description"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.Phone')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>
            <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.TaxNumber') }}</v-card-title>
                </div>
          
          
                <div class="row">
                <v-text-field v-model="companyData.taxIdentificationNumber"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.TaxNumber')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>

            <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.Adresse') }}</v-card-title>
                </div>
          
          
                <div class="row">
                <v-text-field v-model="companyData.address"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.Addresse')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>

            <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.email') }}</v-card-title>
                </div>
          
          
                <div class="row">
                <v-text-field v-model="companyData.email"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.EmailAdresse')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>


            <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('Delivery.Phone') }}</v-card-title>
                </div>
          
          
                <div class="row">
                <v-text-field v-model="companyData.phone"  maxlength="30" hide-details persistent-placeholder
                    :placeholder="$t('Delivery.generalInformation.Phone')" variant="outlined"
                    :readonly="!isDeliveryResult" :class="!isDeliveryResult ? 'readonly-field' : ''"
                    ></v-text-field>
            </div>
            </div>

           

           
        </div>


   
  </template>
  
  <script>
  import { getDeliveryCompanyInformation } from "@/api/index";

  
  export default {
    mounted() {
      this.fetchCompanyDetails();
    },
    props: {
      isDeliveryResult: {
        type: Boolean,
        required: true,
        default: false,
      },
      companyId: {
          type: String,
          required: true,
      },
    },
    components: { },
    data() {
      return {
        companyData: {
          name: "",
          email: "",
          phone: "",
          address: "",
          taxIdentificationNumber: ""
        },
        loader: false,
      };
    },
    methods: {
      fetchCompanyDetails() {
        this.loading = true;
        getDeliveryCompanyInformation(this.companyId)
          .then((response) => {
            this.companyData = response.data;
          })
          .catch((error) => {
            console.error("Error fetching company information:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      saveCompanyDetails() {
        // Implémentez la sauvegarde si nécessaire
        alert("Data saved!");
      },
    }
   
  };
  </script>
  
  <style scoped>
.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>